import { jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useEffect, useState } from "react";
import { SelectPicker } from "rsuite";
const SingleSelect = (props) => {
    const { placeholder, setValue, value, block } = props;
    const [data, setData] = useState([{}]);
    useEffect(() => {
        setData(props.data.map((item) => ({ label: item, value: item })));
    }, [props.data]);
    return (_jsx(SelectPicker, { data: data, searchable: false, value: value, onChange: setValue, placeholder: placeholder, block: block }));
};
export default SingleSelect;
